// gtm.js
import TagManager from "react-gtm-module";
const gtmId = "GTM-WZTLLKDB"; // Replace with your GTM ID

export const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};
